// Agregar este código a un archivo JS externo
document.addEventListener('DOMContentLoaded', function() {
    // Inicializar productos favoritos
    initFavoriteProducts();
  });
  
  function initFavoriteProducts() {
    // Buscar todos los productos guardados en localStorage
    const allProducts = document.querySelectorAll('.container-like');
    
    allProducts.forEach(product => {
      const handle = product.getAttribute('handle');
      if(window.localStorage.getItem("product_favorite_v2_" + handle)) {
        product.classList.remove('like_disable');
        product.classList.add('like_active');
      }
      
      // Usar delegación de eventos en lugar de onclick inline
      product.addEventListener('click', likeProduct);
    });
  }
  
  function likeProduct(event) {
    event.preventDefault();
    const productCard = event.currentTarget;
    const handle = productCard.getAttribute('handle');
    
    if(productCard.classList.contains('like_active')) {
      window.localStorage.removeItem("product_favorite_v2_" + handle);
      productCard.classList.remove('like_active');
      productCard.classList.add('like_disable');
    } else {
      window.localStorage.setItem("product_favorite_v2_" + handle, "true");
      productCard.classList.remove('like_disable');
      productCard.classList.add('like_active');
    }
  }